<template>
  <div class="card-analitica sub-card">
    <div class="sub-info-section">
      <div class="icon-box">
        <Icon :name="icon" />
      </div>
      <div class="title-value-wrapper">
        <span class="card-title">{{ title }}</span>
        <div class="value-section">
          <span class="value-text">R$ {{ value }}</span>
        </div>
      </div>
    </div>
    <div class="action-icon-box">
      <a :href="link" class="icon-link" :title="'Acessar ' + title">
        <i class="fas fa-external-link-alt"></i>
      </a>
    </div>
  </div>
</template>

<script>
import Icon from "../../../components/icon/Icon.vue";

export default {
  name: "SummaryCard",
  components: {
    Icon,
  },
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    icon: { type: String, default: "icon-backbeat" },
    link: { type: String, default: "#" },
  },
};
</script>

<style lang="scss" scoped>
.card-analitica {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  border: 1px solid #DFDFDF;
}

.sub-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  height: 88px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .sub-info-section {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .icon-box {
      width: 24px;
      height: 24px;
      color: #007A4A;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .card-title {
      font-size: 16px;
      line-height: 24px;
      color: #232428;
    }

    .value-text {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: #00423E;
    }
  }

  .action-icon-box {
    .icon-link {
      color: #007A4A;
      font-size: 18px;
    }
  }
}
</style>